import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const telegramUrl = 'https://t.me/saharacopytrade';

  const handleTelegramClick = () => {
    window.open(telegramUrl, '_blank');
  };

  return (
    <>
      <div 
        className="whatsapp-float telegram-float"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={handleTelegramClick}
      >
        <MessageCircle className="whatsapp-icon" />
        <span className="whatsapp-pulse"></span>
      </div>
      
      {showTooltip && (
        <div className="whatsapp-tooltip">
          <p>Join us on Telegram!</p>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
